import * as React from "react";
const SvgFiRrGlassEmpty = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22.212.973A3 3 0 0 0 20 0H4c-.836 0-1.64.353-2.206.967a3 3 0 0 0-.784 2.279L2.339 19.41C2.551 21.984 4.74 24 7.322 24h9.263a4.97 4.97 0 0 0 4.98-4.562l1.422-16.175a3.01 3.01 0 0 0-.775-2.29m-1.216 2.115-1.422 16.175A2.984 2.984 0 0 1 16.586 22H7.323a3.02 3.02 0 0 1-2.99-2.754L3.003 3.082a1 1 0 0 1 .261-.76A.99.99 0 0 1 3.999 2h16c.284 0 .546.115.737.324s.284.48.26.764"
    />
  </svg>
);
export default SvgFiRrGlassEmpty;
